// Packages
import React, { useState, useEffect } from "react";

// MUI Components
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";


import DialogTitle from "@material-ui/core/DialogTitle";
//import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from "@material-ui/icons/Clear";

import { LinearProgress } from "@material-ui/core";

// Styles
import { useStyles } from "./styles";

// Services
import * as AssetApi from "apis/AssetApi";
import { pdfToBlob } from "util/commonUtil";

import AAISPDFViewerTabs from './tabs.js';

export default function AAISPDFViewerDialog(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState();
  const [newFile, setNewFile] = useState(null);
  const [pdfData, setPdfData] = useState();

  useEffect(() => {
    init();
  }, [props.files]);

  useEffect(() => {
    setLoading(true);
    async function fetchUrl() {
      if(newFile && newFile != null){
        const result = await getPDF(newFile);
        if(result === true){
          setLoading(false);
        }
      }
    }
    fetchUrl();
  }, [newFile]);

  async function init() {
    const files = props.files;
    if(files.length > 0 && files[0] != null){
      setLoading(true);
      const result = await getPDF(files[0]);
      if(result === true){
        setLoading(false);
      }
    } 
  }

  async function getPDF(newFile){
    try{
      const response = await AssetApi.getSignedUrlV1(newFile);
      const encodedUrl = response.url;//encodeURIComponent(response.url);
      const blobUrl = await pdfToBlob(response.url);
      setPdfData(blobUrl);
      setUrl(encodedUrl);
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  return (
    <Dialog open={true} onClose={props.handleClose} maxWidth="xl" fullWidth>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContentText className={classes.rightContent} onClick={props.handleClose} color="primary">
          <ClearIcon></ClearIcon>
      </DialogContentText>
      {props.files.length > 1 && (
        <AAISPDFViewerTabs
        files = {props.files}
        newFile = {newFile} 
        setNewFile = {setNewFile}
        title = {props.title}
        ></AAISPDFViewerTabs>
      )}
      <DialogContent className={classes.content}>
        {loading && <LinearProgress />}
        {url && pdfData && (
          <object
          data={pdfData}
          height="98%"
          title={props.title}
          width="100%"
          type="application/pdf"
          allow="*"
          target="_blank"
          referrerPolicy="no-referrer"
          >
            <embed src={pdfData} type="application/pdf"></embed> 
          </object>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
